import { AgeGroup } from 'constants/components'
import { getAgeGroupFromAge } from 'utils/userState'

export const TIMEOUT_TWO_MINUTES = 120000 // 2 minutes
export const TIMEOUT_THREE_MINUTES = 180000 // 3 minutes
export const TIMEOUT_FIVE_MINUTES = 300000 // 5 minutes

/**
 * Determines the inactivity timeout for the DAC flow based on the debtor's
 * age group and whether the shorter old-age timeout applies.
 *
 * @param debtorsAge The debtor's age in years.
 * @param isOldAgeShorterTimeout Whether old-age users should use two minutes.
 * @param isCat4784MiddleAgeTreatment Whether middle-age users should use three minutes.
 * @returns The timeout duration in milliseconds.
 */
export const determineInactivityTimeout = (
  debtorsAge: number,
  isOldAgeShorterTimeout: boolean,
  isCat4784MiddleAgeTreatment = false
): number => {
  const ageGroup = getAgeGroupFromAge(debtorsAge)

  if (ageGroup === AgeGroup.YOUNG_AGE_GROUP) {
    return TIMEOUT_THREE_MINUTES
  }
  if (ageGroup === AgeGroup.MIDDLE_AGE_GROUP) {
    return isCat4784MiddleAgeTreatment
      ? TIMEOUT_THREE_MINUTES
      : TIMEOUT_TWO_MINUTES
  }
  if (ageGroup === AgeGroup.OLD_AGE_GROUP && isOldAgeShorterTimeout) {
    return TIMEOUT_TWO_MINUTES
  }
  return TIMEOUT_FIVE_MINUTES
}
